// // src/hooks/update-hooks/billing/create-hinai-billing.js

// import { useMutation } from "react-query";
// import { request } from "../../../config/helpers/axios-instance";
// import { toast } from "react-toastify";

// export const CreateHinaiBilling = () => {
//     const USE_MOCK_DATA = true; // Set to false to use real API

//     return useMutation(
//         ['create-hinai-billing'],
//         async (payload) => {
//             if (USE_MOCK_DATA) {
//                 // Mock API response
//                 return new Promise((resolve) => {
//                     setTimeout(() => {
//                         resolve({
//                             data: {
//                                 success: true,
//                                 data: {
//                                     invoiceNo: "INV-D-1000-26000010"
//                                 },
//                                 error: ""
//                             }
//                         });
//                     }, 1000);
//                 });
//             } else {
//                 // Real API call
//                 const response = await request({
//                     method: "POST",
//                     url: `/hinai/userorder/billing`, // Adjust endpoint as needed
//                     data: payload
//                 });
//                 return response;
//             }
//         },
//         {
//             onSuccess: (response) => {
//                 if (response?.data?.success) {
//                     toast.success(response?.data?.data?.message || "Billing entry created successfully");
//                 } else {
//                     toast.error(response?.data?.error || "Failed to create billing entry");
//                 }
//             },
//             onError: (error) => {
//                 toast.error("Failed to create billing entry in Hinai system", error);
//             }
//         }
//     );
// };

// convert it to the real api call
import { useMutation } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";
import { TENANT_COMPANY_MAP } from "../../../utils/constants";
import { getTenantId } from "../../../utils/helpers";

const CreateHinaiBilling = (userOrderId) => {
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;

    if (!isEasydose) {
        // No‑op mutation for non‑Easydose
        return useMutation(() => Promise.resolve(null));
    }

    return useMutation(
        ["create-hinai-billing", userOrderId],
        () => request({ url: `/hinai/userorder/createBillingOrder/${userOrderId}`, method: "POST" }),
        {
            onSuccess: (response) => {
                if (response?.data?.success) {
                    toast.success(response?.data?.data?.message || "Billing entry created successfully");
                } else {
                    toast.error(response?.data?.error || "Failed to create billing entry");
                }
            },  
            onError: (error) => {
                const errorMessage = error?.response?.data?.error || 
                                    error?.message || 
                                    "Failed to create billing entry";
                toast.error(errorMessage);
            }
        }
    );
};

export { CreateHinaiBilling };